export default __webpack_public_path__ + "static/media/analyticsIcon.81a1a428.svg";